import togglePercentagesComponent from './togglePercentagesComponent';
import maxValueValidEditor from './maxValueValidEditor';

const columnDefs = [
  {
    children: [
      {
        headerName: 'Service Name',
        field: 'service',
        width: 280,
      },
    ],
  },
  {
    headerName: 'CPT/HCPCS',
    field: 'code',
    width: 100,
  },
  {
    headerName: 'Percentage of Patients Undergoing',
    field: 'percent',
    width: 130,
    cellEditor: maxValueValidEditor,
    cellRenderer: percentFormat,
    cellClass: (params) => (
      // 'percent-undergoing' will add the arrow in ::before element
      // we do not want the arrow for the first row of the table.
      0 !== params.rowIndex ?
      ['editable', 'percent-undergoing'] : 'first-row'
    ),
    editable: (params) => 0 !== params.node.childIndex,
  },
  {
    headerName: 'Number of Services<sup>1</sup>',
    field: 'totalNumber',
    width: 130,
    cellClass: (params) => (
      // 'total-services' will add the arrow in ::before element
      // we do not want the arrow for the first row of the table.
      0 !== params.rowIndex ?
      ['editable', 'total-services'] : ['editable', 'first-row']
    ),
    cellEditor: maxValueValidEditor,
    cellRenderer: (params) => (
      `<div>${
        isNaN(parseInt(params.value, 10)) ?
          params.value :
          Intl.NumberFormat().format(params.value)
      }</div>`
    ),
    editable: true,
  },
  {
    headerName: 'View Percentages:',
    headerGroupComponent: togglePercentagesComponent,
    headerClass: 'group-highlight',
    openByDefault: true,
    children: [
      {
        headerName: 'National MPFS Professional Percentage<sup>2</sup>',
        field: 'professionalPricingPercent',
        width: 130,
        cellRenderer: percentFormat,
        headerClass: 'group-highlight',
        cellClass: ['group-highlight', 'editable'],
        editable: true,
        columnGroupShow: 'closed',
      },
      {
        headerName: 'National MPFS Technical Percentage<sup>2</sup>',
        field: 'technicalPricingPercent',
        width: 130,
        cellRenderer: percentFormat,
        headerClass: 'group-highlight',
        cellClass: ['group-highlight', 'editable'],
        editable: true,
        columnGroupShow: 'closed',
      },
      {
        headerName: 'National MPFS Professional<sup>2</sup>',
        field: 'professionalPricing',
        width: 130,
        cellRenderer: currencyFormatUSD,
        headerClass: 'group-highlight',
        cellClass: ['group-highlight', 'editable'],
        editable: true,
        columnGroupShow: 'open',
      },
      {
        headerName: 'National MPFS Technical<sup>2</sup>',
        field: 'technicalPricing',
        width: 130,
        cellRenderer: currencyFormatUSD,
        headerClass: 'group-highlight',
        cellClass: ['group-highlight', 'editable'],
        editable: true,
        columnGroupShow: 'open',
      },
    ],
  },
  {
    headerName: 'National MPFS Global',
    field: 'nationalGlobal',
    width: 130,
    valueGetter: (params) =>
      (
        +params.data.professionalPricing +
        +params.data.technicalPricing
      ).toFixed(2),
    cellRenderer: currencyFormatUSD,
  },
  {
    headerName: 'Weighted Professional',
    field: 'weightedProfessional',
    width: 130,
    valueGetter: (params) =>
      (+params.data.percent * +params.data.professionalPricing) / 100,
    cellRenderer: currencyFormatUSD,
    hide: true,
  },
  {
    headerName: 'Weighted Technical',
    field: 'weightedTechnical',
    width: 130,
    valueGetter: (params) =>
      (+params.data.percent * +params.data.technicalPricing) / 100,
    cellRenderer: currencyFormatUSD,
    hide: true,
  },
  {
    headerName: 'Weighted Global',
    field: 'weightedGlobal',
    width: 130,
    valueGetter: (params) => {
      const valueGetter =
        params.api.getColumnDef('nationalGlobal').valueGetter;
      return (
        +params.data.percent * valueGetter({ data: params.data })
      ) / 100;
    },
    cellRenderer: currencyFormatUSD,
    hide: true,
  },
];

function percentFormat(params) {
  const editable = params.colDef.editable;
  const formatted = `${parseFloat(params.value, 10).toFixed(1)}%`;
  return editable ? `<div>${formatted}</div>` : formatted;
}

function currencyFormatUSD(params) {
  const editable = params.colDef.editable;
  const formatted =
    Intl.NumberFormat(
      'en-US', { style: 'currency', currency: 'USD' }
    ).format(params.value);

  return editable ? `<div>${formatted}</div>` : formatted;
}

export default columnDefs;



// WEBPACK FOOTER //
// ./app/config/table.js